import type { TelemetryReplayChunk } from '../generated-api';

/** Inverse of telemetry.gzipBase64: base64 -> gunzip -> text. */
export const gunzipBase64 = async (data: string): Promise<string> => {
  const DS = (globalThis as any).DecompressionStream;
  if (!DS) throw new Error('This browser cannot decompress replays (no DecompressionStream)');
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const stream = new Blob([bytes]).stream().pipeThrough(new DS('gzip'));
  return new Response(stream).text();
};

/** Decode stored replay chunks into one ordered rrweb event list. */
export const decodeReplayChunks = async (chunks: TelemetryReplayChunk[]): Promise<any[]> => {
  const ordered = [...chunks].sort((a, b) => a.seq - b.seq);
  const events: any[] = [];
  for (const chunk of ordered) {
    const text = chunk.encoding === 'gzip-base64' ? await gunzipBase64(chunk.data) : chunk.data;
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) events.push(...parsed);
  }
  return events.sort((a, b) => (a?.timestamp ?? 0) - (b?.timestamp ?? 0));
};
